import React from "react";
import PropTypes from "prop-types";
import chroma from "chroma-js";

import { colors } from "../../../../theme";
import CovidLethalityMap from "./CovidLethalityMap";

function CovidLethalityMapDead({ version, deadZoomState }) {
  const scaleColor = chroma
    .scale([chroma(colors.red).brighten(2), chroma(colors.red).darken(1.5)])
    .classes(6);

  function getLocationColor(data) {
    if (data < 50) {
      return scaleColor(0);
    } else if (data < 100) {
      return scaleColor(1 / 6);
    } else if (data < 150) {
      return scaleColor(2 / 6);
    } else if (data < 250) {
      return scaleColor(3 / 6);
    } else if (data <= 300) {
      return scaleColor(4 / 6);
    } else {
      return scaleColor(5 / 6);
    }
  }

  return (
    <CovidLethalityMap
      version={version}
      type="deces"
      typeLabel="Décès Covid-19"
      legend={{
        title: "Décès officiels Covid-19",
        categories: [
          "Moins de 50",
          "Entre 50 et 100",
          "Entre 100 et 150",
          "Entre 150 et 250",
          "Entre 250 et 300",
          "Plus de 300",
        ],
        note:
          "Nombre de décès officiellement attribués au Covid-19 au 30 mars 2020.",
      }}
      getLocationColor={getLocationColor}
      scaleColor={scaleColor}
      {...deadZoomState}
    />
  );
}

CovidLethalityMapDead.propTypes = {
  version: PropTypes.oneOf(["v1", "v2"]).isRequired,
  deadZoomState: PropTypes.object.isRequired,
};

export default CovidLethalityMapDead;
